<template>
  <div>
    <div>
      <SLandingTopBar v-if="Object.keys(user).length === 0" />
      <SubHeaderCategories pageName="Contact Us" :backButtonCategories="true" />
    </div>
    <div class="page-has-left-panels page-has-right-panels">
      <section
        class="
          contact-section
          medium-padding120
          bg-body
          contact-form-animation
          scrollme
          allow-overflow
        "
      >
        <div class="container container-contact">
          <div class="row">
            <div
              class="
                col col-xl-10 col-lg-10 col-md-12 col-sm-12
                m-auto
                allow-overflow
              "
            >
              <!-- Contacts Form -->

              <span class="contact-title">How can we help?</span>
              <span class="contact-text">Submit the contact form below with any questions
              or comments you might have.  We look forward to hearing from you!</span>

              <div class="">
                <form class="contact-form">
                  <div class="row">
                    <div class="col col-12 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                      <div class="form-group label-floating">
                        <label class="control-label">Name</label>
                        <input
                          class="form-control"
                          placeholder
                          type="text"
                          v-model="firstName"
                          ref="firstName"
                          data-cy="contactUsFirstName"
                        />
                      </div>

                      <div class="form-group label-floating">
                        <label class="control-label">Email<span class="required-field">*</span></label>
                        <input
                          class="form-control"
                          placeholder
                          type="email"
                          v-model="email"
                          data-cy="contactUsEmail"
                        />
                      </div>

                      <div class="form-group label-floating is-select">
                        <label class="control-label"
                          >Subject <span class="required-field">*</span></label
                        >

                          <select
                            class="selectpicker form-control arrange"
                            v-model="subject"
                            data-cy="contactUsSelectPicker"
                          >
                            <option :value="null" disabled>
                              -- Select a subject --
                            </option>
                            <option value="Account">Account</option>
                            <option value="Items">Items</option>
                            <option value="Trade">Trade type</option>
                            <option value="Groups">Groups</option>
                            <option value="Points">Points</option>
                            <option value="Other">Other</option>
                          </select>

                      </div>

                      <div class="form-group label-floating ">
                        <label class="control-label"
                          >Your message
                          <span class="required-field">*</span></label
                        >
                        <textarea
                          class="form-control"
                          v-model="message"
                          ref="yourMessage"
                          data-cy="contactUsMessage"
                        ></textarea>
                      </div>
                      <VueRecaptcha
                        data-cy="contactUsRecaptcha"
                        ref="recaptcha"
                        sitekey="6Lf3LBUkAAAAAJ22qESbD2XyypnBXc2RwkFBieoZ"
                        @verify="checkRecaptcha"
                        @expired="recaptcha = false"
                      >
                      </VueRecaptcha>
                      <div class="text-center">
                        <button
                          class="btn btn-size btn-blue btn-sm"
                          :disabled="shouldSendBeDisabled"
                          @click.prevent="openModal('#submit-message')"
                          data-cy="contactUsSendMessage"
                        >
                          Submit
                          <div
                            v-if="getRequestResponse === 'SENDING'"
                            class="
                              spinner-border spinner-border-sm
                              text-primary
                              ml-3
                            "
                            role="status"
                          >
                            <span class="sr-only">Loading...</span>
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <!-- ... end Contacts Form -->
            </div>
          </div>
        </div>
      </section>
      <CookiesAndPrivacy v-if="!storageCookies" @cookies-privacy="accept" />
    </div>
    <Footer v-if="isUserAuthenticated"/>
    <FooterUnlogged v-else/>
    <Modal
      backButtonName="CANCEL"
      :backButtonVisible="true"
      :isBackButton="true"
      :backArrowDisabled="false"
      :backButtonRed="true"
      buttonName="CONFIRM"
      id="submit-message"
      title="Submit message"
      ref="submitMessage"
      data-cy="contactUsSubmitMessage"
      :materialButton="false"
      @back="closeModal($refs.submitMessage)"
      @button="sendSupportMessage"
    >
      <p class="welcome-title">Confirm this submission?</p>
    </Modal>

    <Modal
      buttonName="CLOSE"
      id="submit-confirmation"
      title="Submit message"
      ref="submitConfirmation"
      :materialButton="false"
      @button="closeModal($refs.submitConfirmation)"
    >
      <p class="welcome-title" data-cy="contactUsSubmitConfirmation">{{ modalMessage }}</p>
    </Modal>

  </div>
</template>

<script>
import SLandingTopBar from "@/material-components/organisms/SLandingTopBar.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import CookiesAndPrivacy from "@/components/molecules/CookiesAndPrivacy";
import SubHeaderCategories from "@/material-components/molecules/SubHeaderCategories.vue";
import Modal from "@/components/atoms/Modal.vue";
import { VueRecaptcha } from 'vue-recaptcha';
import Footer from "@/templates/Footer";
import FooterUnlogged from "@/templates/FooterUnlogged";

export default {
  name: "ContactUs",
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      subject: null,
      message: "",
      modalMessage:"",
      cookiesPrivacy: localStorage.getItem("cookies_privacy"),
      recaptcha: false,
    };
  },
  components: {
    CookiesAndPrivacy,
    SubHeaderCategories,
    SLandingTopBar,
    Modal,
    Footer,
    FooterUnlogged,
    VueRecaptcha
  },
  methods: {
    ...mapActions(["startSession", "sendSupportRequest", "fetchUserMessages"]),
    ...mapMutations({
      changeFeedbackMessage: "set_request_response",
    }),
    checkRecaptcha() {
      this.recaptcha = true;
    },
    async start() {
      this.startSession();
      this.fetchUserMessages();
    },
    async sendSupportMessage() {
      if (this.shouldSendBeDisabled) return;

      const message = `${this.subject}: ${this.message}`;
      const user = {
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
      };

      this.sendSupportRequest({ message, user });
      this.closeModal(this.$refs.submitMessage);
      this.$refs.recaptcha.reset();
      this.recaptcha = false;

    },
    openModal(modal) {
      $(modal).modal("show");
    },
    closeModal(modal){
      modal.closeModal();
    },
    accept(a) {
      this.cookiesPrivacy = a;
    },
    clearForm() {
      this.firstName= "";
      this.lastName= "";
      this.email= "";
      this.subject= null;
      this.message= "";
    },
  },
  computed: {
    ...mapGetters({
      isUserAuthenticated: "isUserAuthenticated",
      userMsgs: "getUserMessages",
      getRequestResponse: "getRequestResponse",
      user: "getUser",
    }),
    shouldSendBeDisabled() {
      if (process.env.NODE_ENV === 'test') {
        return !this.message || !this.email || !this.subject
      }
      return !this.message || !this.email || !this.subject || !this.recaptcha;
    },
    storageCookies() {
      return this.cookiesPrivacy;
    },
  },
  watch: {
    user(newValue) {
      if (newValue.firstName) this.firstName = newValue.firstName;
      if (newValue.lastName) this.lastName = newValue.lastName;
      if (newValue.email) this.email = newValue.email;
      this.$refs.yourMessage.focus();
    },
    getRequestResponse(){
      if(this.getRequestResponse === 'SENT'){
        this.modalMessage = "Message sent!";
        this.clearForm();
      this.openModal($("#submit-confirmation"));
      }
      else if(this.getRequestResponse === 'ERROR'){
        this.modalMessage = "Error sending message Please try again later";
        this.openModal($("#submit-confirmation"));
      }
    },
  },
  created() {
    if (this.isUserAuthenticated) {
      this.start();
    }
  },
  mounted() {
    this.$refs.firstName.focus();

    // Load select tag when entering route
    $(function () {
      $(".selectpicker").selectpicker();
    });
  },
  beforeDestroy() {
    this.changeFeedbackMessage("");
  },
};
</script>

<style>
.back-btn {
  display: block;
  margin-bottom: 1rem;
  font-size: 1.6em;
  padding-left: 10%;
  padding-top: 15%;
}

.required-field {
  color: crimson;
}

.allow-overflow {
  overflow: visible;
}
.container-contact {
  margin-top: 150px;
}
.suggestions-title {
  display: flex;
  color: darkslategray;
  font-size: x-large;
  -webkit-text-stroke: thin;
  position: initial;
  margin: 0;
}
.suggestions-container {
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 30px 0;
  text-align: center;
}
.suggestions-container span {
  margin-left: 8px;
}
.suggestions-container a {
  text-decoration: none;
}
.suggestion {
  box-shadow: 0px 2px 3px #888da8;
  cursor: pointer;
  width: 33%;
  padding: 7px;
  border-radius: 4px;
  border: 1.5px solid #05919B;
  color: #05919B;
}
.current-page {
  background: #05919B;
  color: white !important;
  box-shadow: 0px 2px 3px #888da8;
  cursor: pointer;
  width: 27%;
  padding: 7px;
  border-radius: 4px;
  border: 1.5px solid #05919B;
}
.contact-title {
  display: flex;
  justify-content: space-evenly;
  color: darkslategray;
  font-size: xx-large;
  -webkit-text-stroke: thin;
  padding-bottom: 15px;
  position: initial;
  margin: 0;
  background-color: white;
}
.contact-title::after {
  background-color: white;
}
.arrange {
  margin-left: -1px;
}
.contact-text {
  display: flex;
  text-align: center;
  font-size: 20px;
}
.bg-body {
  background-color: white;
  padding: 50px 0;
}
.contact-section {
  margin-right: 70px;
}
@media  screen and (max-width: 768px) {
  .contact-section {
    margin-right: 0px;
  }
}
.form-group {
  border-radius: .25rem;
}
</style>

<style scoped>
.title {
  font-size: 34px !important;
}

p,
input {
  font-size: 14px !important;
}
.btn-size {
  width: 115px;
}
</style>
